var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "little-b-risk-box" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "search-criteria" },
        [
          _c("el-input", {
            attrs: { placeholder: "输入手机号查询", clearable: "" },
            model: {
              value: _vm.queryData.phone,
              callback: function ($$v) {
                _vm.$set(_vm.queryData, "phone", $$v)
              },
              expression: "queryData.phone",
            },
          }),
          _vm._v(" "),
          _c("el-input", {
            attrs: { placeholder: "输入支付宝号查询", clearable: "" },
            model: {
              value: _vm.queryData.alipayAccount,
              callback: function ($$v) {
                _vm.$set(_vm.queryData, "alipayAccount", $$v)
              },
              expression: "queryData.alipayAccount",
            },
          }),
          _vm._v(" "),
          _c(
            "el-select",
            {
              attrs: { placeholder: "选择风控状态", clearable: "" },
              model: {
                value: _vm.queryData.riskStatus,
                callback: function ($$v) {
                  _vm.$set(_vm.queryData, "riskStatus", $$v)
                },
                expression: "queryData.riskStatus",
              },
            },
            [
              _c("el-option", { attrs: { label: "风控中", value: "1" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "解除风控", value: "0" } }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "date-range" },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "datetimerange",
                  "range-separator": "至",
                  "start-placeholder": "风控开始时间",
                  "end-placeholder": "风控结束时间",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                },
                model: {
                  value: _vm.queryData.timeRange,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryData, "timeRange", $$v)
                  },
                  expression: "queryData.timeRange",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn-group" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onInquire } },
                [_vm._v("查询")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "info", plain: "" },
                  on: { click: _vm.onInitialize },
                },
                [_vm._v("重置")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    icon: "el-icon-circle-plus-outline",
                  },
                  on: { click: _vm.onAdd },
                },
                [_vm._v("新增")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-area" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                "header-cell-style": { "text-align": "center" },
                "cell-style": { "text-align": "center" },
                data: _vm.tableData,
                border: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "风控会员信息", "min-width": "140" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "member-info",
                            staticStyle: {
                              cursor: "pointer",
                              color: "#4d8aff",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onUserDetails(scope.row)
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "nickname" }, [
                              _vm._v(_vm._s(scope.row.nickname)),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "uid" }, [
                              _vm._v("UID:" + _vm._s(scope.row.uid)),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "手机号", prop: "phone", "min-width": "130" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "支付宝账号",
                  prop: "alipayAccount",
                  "min-width": "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.alipayAccount || "-")),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "支付宝名称",
                  prop: "alipayName",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "风控原因",
                  prop: "riskReason",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "风控时间",
                  prop: "riskTime",
                  "min-width": "170",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "风控状态", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: "关闭后该会员将解除风控状态，加入白名单",
                              placement: "top",
                            },
                          },
                          [
                            _c("el-switch", {
                              attrs: {
                                "active-value": 1,
                                "inactive-value": 0,
                                "active-color": "#13ce66",
                                "inactive-color": "#dcdfe6",
                              },
                              on: {
                                change: function (val) {
                                  return _vm.onRiskStatusChange(scope.row, val)
                                },
                              },
                              model: {
                                value: scope.row.riskStatus,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "riskStatus", $$v)
                                },
                                expression: "scope.row.riskStatus",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.queryData.page.page,
                  "page-sizes": [10, 20, 30, 50],
                  "page-size": _vm.queryData.page.size,
                  total: _vm.pagination.total,
                  background: "",
                  layout: "total, prev, pager, next, jumper",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            width: "800px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.onDialogClose,
          },
        },
        [
          _vm.existRiskTip
            ? _c("div", { staticClass: "exist-risk-tip" }, [
                _c("i", { staticClass: "el-icon-warning" }),
                _vm._v(" 当前用户已被风控\n    "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "riskForm",
              staticClass: "risk-form",
              attrs: {
                model: _vm.formData,
                rules: _vm.formRules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "风控账号类型：", prop: "accountType" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.onAccountTypeChange },
                      model: {
                        value: _vm.formData.accountType,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "accountType", $$v)
                        },
                        expression: "formData.accountType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("注册的手机号"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("关联的支付宝账号"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "输入账号：", prop: "account" } },
                [
                  _c(
                    "div",
                    { staticClass: "account-input-wrap" },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入要风控的手机号或支付宝账号",
                          clearable: "",
                        },
                        model: {
                          value: _vm.formData.account,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "account", $$v)
                          },
                          expression: "formData.account",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "search-user-btn",
                          attrs: { type: "text" },
                          on: { click: _vm.onSearchUser },
                        },
                        [_vm._v("搜索用户")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-tip" }, [
                    _vm._v("提交后将向平台风控管家添加至共享风控名单库"),
                  ]),
                  _vm._v(" "),
                  _vm.searchResults.length > 0
                    ? _c(
                        "div",
                        { staticClass: "search-results" },
                        _vm._l(_vm.searchResults, function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "user-card" },
                            [
                              _c("img", {
                                staticClass: "user-avatar",
                                attrs: { src: item.icon, alt: "头像" },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "user-info" }, [
                                _c("div", { staticClass: "user-name" }, [
                                  _vm._v(_vm._s(item.memberName)),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "user-uid" }, [
                                  _vm._v("UID:" + _vm._s(item.memberId)),
                                ]),
                              ]),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "风控原因：", prop: "riskReason" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入", clearable: "" },
                    model: {
                      value: _vm.formData.riskReason,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "riskReason", $$v)
                      },
                      expression: "formData.riskReason",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-tip" }, [
                    _vm._v(
                      "常见风控原因参考：恶意维权、违规拉新、恶意刷单、违规套利、其他"
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onConfirm } },
                [_vm._v("确认")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.onReset } }, [_vm._v("重置")]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tips-area" }, [
      _c("p", [
        _c("span", { staticClass: "tag" }, [_vm._v("【添加风控名单】")]),
        _vm._v(
          "：以会员为纬度，添加并设置为风控状态，该会员将自动禁用提现（不影响其转链下单），添加成功后将提取该会员手机号/支付宝账号自动上报至共享风控名单库"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _c("span", { staticClass: "tag" }, [_vm._v("【风控状态】")]),
        _vm._v(
          "：关闭后，该会员将加入白名单，允许加入白名单的账号进行提现操作"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }